import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useAccontStore } from '@/stores/AccountStore.js'
import {
	resourceSchema,
	RESOURCE_NAMES,
	readResources,
	parseResource,
} from '@/api/api.js'




export const organizationSchema = Object.freeze(Object.assign(
	{},
	resourceSchema,
	{
		title: Object.freeze({
			key:  'title',
		}),
		role: Object.freeze({
			key: 'role',
			title: '',
			allowed: Object.freeze({
				primary: {
					primary: 'measure_potential_on_off_station',
					title: '',
				},
				secondary: {
					key: 'secondary',
					title: '',
				},
			}),
		}),
		departmentTitle: Object.freeze({
			key:  'department_title',
			title: '',
		}),
		sectorTitle: Object.freeze({
			key:  'sector_title',
			title: '',
		}),
		departments: Object.freeze({
			key:  'departments',
			thisTitle: '',

			id: Object.freeze({
				key:  'id',
				title: '',
			}),
			title: Object.freeze({
				key:  'title',
				title: '',
			}),
			sectors: Object.freeze({
				key:  'sectors',
				thisTitle: '',

				id: Object.freeze({
					key:  'id',
					title: '',
				}),
				title: Object.freeze({
					key:  'title',
					title: '',
				}),
			}),
		}),
		pipelines: Object.freeze({
			key:  'pipelines',
			thisTitle: '',

			id: Object.freeze({
				key:  'id',
				title: '',
			}),
			title: Object.freeze({
				key:  'title',
				title: '',
			}),
		}),
		map: Object.freeze({
			key:  'map',
			title: '',

			startLocation: Object.freeze({
				key:  'start_location',
				title: '',
			}),
			startZoom: Object.freeze({
				key:  'start_zoom',
				title: '',
			}),
		}),
		relationGraph: Object.freeze({
			key:  'relation_graph',
			title: '',
		}),
		mapApiKey: Object.freeze({
			key:  'map_api_key',
			title: '',
		}),
		influxApiKey: Object.freeze({
			key:  'influx_api_key',
			title: '',
		}),
		gotifyUser: Object.freeze({
			key:  'gotify_user',
			title: '',
		}),
		gotifyPass: Object.freeze({
			key:  'gotify_pass',
			title: '',
		}),
	},
))




// "Date" type pasport fields (flatten object keys)
const ORGANIZATION_DATE_PATHS = [
	organizationSchema.updateTime.key,
	organizationSchema.createTime.key,
]




// TODO: full CRUD support for OrganizationView.vue
/**
 * 
 * @param {ResourceId} organizationId - if need only one organization
 * @returns 
 */
export function useOrganizations(organizationId=null) {
	const accountStore = useAccontStore()

	const organizationsQuery = useQuery({
		// Include auth identity and time filter in key to auto-refetch on change
		queryKey: [ RESOURCE_NAMES.rpc, organizationId, ],
		queryFn: async () => {
			let isWhereInArgs = false
			const whereObject = {}

			if (organizationId !== null) {
				isWhereInArgs = true
				whereObject[organizationSchema.id.key] = organizationId
			}
			
			// console.log('fetch args', args)
			const res = await readResources(
				RESOURCE_NAMES.organizations,
				accountStore.userLogin,
				accountStore.userPassword,
				[...(isWhereInArgs ? [`where=${JSON.stringify(whereObject)}`] : [])],
			)
			// console.log('fetch res', res)

			return res.map((el) => parseResource(el, ORGANIZATION_DATE_PATHS))
		},
	})

	const allOrganizations = computed(() => organizationsQuery.data.value ?? [])

	const organizationsMap = computed(() =>  {
		return new Map(
			allOrganizations.value.map((org) => [org[organizationSchema.id.key], org])
		)
	})

	// function getOrganization(id) {
	// 	return allOrganizations.value.find((el) => el[organizationSchema.id.key] == id)
	// }

	return {
		organizationSchema,

		allOrganizations,
		isLoading: organizationsQuery.isLoading,
		isError: organizationsQuery.isError,
		error: organizationsQuery.error,
		
		organizationsMap,
		// getOrganization,
	}
}